<template>
    <div class="md:ppv2-w-[80%] ppv2-w-full">
        <!-- Info Banner -->
        <!-- TODO: Uncomment when InfoBanner.vue is available -->
        <!-- <InfoBanner :text="$t('website_settings.general.sections_banner_info')" class="ppv2-mb-6" /> -->
        <form @submit.prevent="save">
            <div class="ppv2-flex ppv2-flex-col" :style="{ gap: normalizeSize(16, true) }">
                <!-- Section Demande de devis -->
                <SectionCard
                    :title="$t('website_settings.general.demande_devis_section')"
                    v-model="form.enabled_demande_devis"
                    :tooltip="$t('website_settings.general.tooltips.demande_devis')"
                    :hasSubcriptionEssentiel="!hasAccess"
                >
                    <div class="ppv2-grid ppv2-grid-cols-1 md:ppv2-grid-cols-3 ppv2-gap-8">
                        <div v-for="(choice, i) in demandeDevisConfigs" :key="i" class="ppv2-flex ppv2-flex-col ppv2-gap-6">
                            <!-- Logo -->
                            <div>
                                <CustomInputUpload
                                    :label="$t('website_settings.general.demande_devis_image')"
                                    customClassLabel="poppinsLight"
                                    v-model="form[choice.imageModel]"
                                    @input="(file) => handleImageUpload(choice.uploadField, { target: { files: [file] } })"
                                    :required="form.enabled_demande_devis && form[choice.enabledModel]"
                                    recommendedDimensions="400 x 240 px"
                                    :errorText="errors[choice.imageModel]"
                                    :disabled="!hasAccess"
                                />
                            </div>

                            <!-- Titre de section -->
                            <div>
                                <CustomInput
                                    :label="$t('website_settings.general.demande_devis_title')"
                                    :required="form.enabled_demande_devis && form[choice.enabledModel]"
                                    customLabelClass="poppinsLight"
                                    v-model="form[choice.titleModel]"
                                    :placeholder="$t('website_settings.general.demande_devis_title_placeholder')"
                                    :errorText="errors[choice.titleModel]"
                                    :disabled="!hasAccess"
                                />
                            </div>

                            <!-- Description -->
                            <div>
                                <BaseTextarea
                                    :label="$t('website_settings.general.demande_devis_desc')"
                                    :required="form.enabled_demande_devis && form[choice.enabledModel]"
                                    customLabelClass="poppinsLight"
                                    v-model="form[choice.descModel]"
                                    :rows="8"
                                    :useEditor="false"
                                    :placeholder="$t('website_settings.general.demande_devis_desc_placeholder')"
                                    :error="errors[choice.descModel]"
                                    :disabled="!hasAccess"
                                />
                            </div>
                        </div>
                    </div>
                    <!-- Toggles visibilité en bas -->
                    <div class="ppv2-grid ppv2-grid-cols-1 md:ppv2-grid-cols-3 ppv2-gap-8 ppv2-mt-6">
                        <div v-for="(choice, i) in demandeDevisConfigs" :key="'toggle-' + i" class="ppv2-flex ppv2-justify-start">
                            <BaseSwitch
                                :label="form[choice.enabledModel] ? $t('common.visible') : $t('common.invisible')"
                                v-model="form[choice.enabledModel]"
                            />
                        </div>
                    </div>
                </SectionCard>
                <!-- Section Restauration (Masked until backend finalized) -->
                <!-- 
                <SectionCard
                    :title="$t('website_settings.general.restoration_section')"
                    v-model="form.enabled_restauration"
                    :tooltip="$t('website_settings.general.tooltips.restoration')"
                >
                    <div class="ppv2-grid ppv2-grid-cols-1" :style="{gap: normalizeSize(16, true)}">
                        <div>
                            <CustomInput
                                :label="$t('website_settings.general.restoration_title')"
                                v-model="form.title_restauration"
                                :required="form.enabled_restauration"
                            />
                        </div>
                        <div>
                            <BaseTextarea
                                :label="$t('website_settings.general.restoration_desc')"
                                v-model="form.desc_restauration"
                                :rows="5"
                                :useEditor="false"
                                :required="form.enabled_restauration"
                            />
                        </div>
                        <div>
                            <CustomInputUpload
                                :label="$t('website_settings.general.restoration_image')"
                                v-model="form.image_restauration_url"
                                @input="(file) => handleImageUpload('image_restauration', { target: { files: [file] } })"
                                :required="form.enabled_restauration"
                                recommendedDimensions="1800 x 500 px"
                            />
                        </div>
                    </div>
                </SectionCard>
                -->

                <!-- Section Bon Cadeau -->
                <SectionCard
                    :title="$t('website_settings.general.gift_card_section')"
                    v-model="form.enabled_bon_cadeau"
                    :tooltip="$t('website_settings.general.tooltips.gift_card')"
                >
                    <!--:disabled="!data.has_vouchers"-->
                    <template #warning>
                        <InfoBanner
                            variant="warning"
                            :text="$t('website_settings.general.vouchers_warning')"
                            :linkText="$t('website_settings.general.configure_now')"
                            linkUrl="/back-office/prestations"
                        />
                    </template>
                    <div class="ppv2-grid ppv2-grid-cols-1" :style="{ gap: normalizeSize(16, true) }">
                        <div>
                            <CustomInput
                                :label="$t('website_settings.general.gift_card_title')"
                                customLabelClass="poppinsLight"
                                v-model="form.title_bon_cadeau"
                                :required="form.enabled_bon_cadeau"
                                :errorText="errors.title_bon_cadeau"
                            />
                        </div>
                        <div>
                            <BaseTextarea
                                :label="$t('website_settings.general.gift_card_desc')"
                                customLabelClass="poppinsLight"
                                v-model="form.desc_bon_cadeau"
                                :rows="5"
                                :useEditor="false"
                                :required="form.enabled_bon_cadeau"
                                :error="errors.desc_bon_cadeau"
                            />
                        </div>
                        <div>
                            <CustomInputUpload
                                :label="$t('website_settings.general.gift_card_image')"
                                customClassLabel="poppinsLight"
                                v-model="form.image_bon_cadeau_url"
                                @input="(file) => handleImageUpload('image_bon_cadeau', { target: { files: [file] } })"
                                :required="form.enabled_bon_cadeau"
                                recommendedDimensions="1800 x 500 px"
                                :errorText="errors.image_bon_cadeau_url"
                            />
                        </div>
                    </div>
                </SectionCard>

                <!-- Section Partenaires -->
                <SectionCard
                    :title="$t('website_settings.general.partners_section')"
                    v-model="form.enabled_partenaires"
                    :tooltip="$t('website_settings.general.tooltips.partners')"
                >
                    <div
                        class="ppv2-flex ppv2-flex-col ppv2-gap-8"
                        :style="{ paddingTop: normalizeSize(55), paddingBottom: normalizeSize(55) }"
                    >
                        <div
                            v-for="(p, idx) in partners"
                            :key="idx"
                            class="ppv2-relative"
                            :style="{ paddingRight: normalizeSize(55), paddingLeft: normalizeSize(55) }"
                        >
                            <!-- Delete Button -->
                            <div class="ppv2-grid ppv2-grid-cols-1 md:ppv2-grid-cols-[1fr_1.5fr] ppv2-gap-6 ppv2-pb-8">
                                <button
                                    v-if="partners.length >= 0"
                                    type="button"
                                    class="ppv2-absolute ppv2-top-0 ppv2-right-0 ppv2-text-red-400 hover:ppv2-text-red-600 ppv2-transition-colors"
                                    @click="deletePartner(idx)"
                                >
                                    <Trash2 :size="20" color="#FF9C9C" />
                                </button>

                                <!-- Left: Logo -->
                                <div>
                                    <CustomInputUpload
                                        :label="$t('website_settings.general.partner_logo')"
                                        customClassLabel="poppinsLight"
                                        v-model="p.url"
                                        @input="(file) => handlePartnerUpload(idx, { target: { files: [file] } })"
                                        recommendedDimensions="180 x 120 px"
                                        :required="form.enabled_partenaires"
                                        :errorText="partnersErrors[idx]?.url"
                                    />
                                </div>

                                <!-- Right: Name and Link -->
                                <div class="ppv2-flex ppv2-flex-col" :style="{ gap: normalizeSize(16, true) }">
                                    <CustomInput
                                        :label="$t('website_settings.general.partner_name')"
                                        customLabelClass="poppinsLight"
                                        v-model="p.name"
                                        :placeholder="$t('website_settings.general.partner_name_placeholder')"
                                        :required="form.enabled_partenaires"
                                        :errorText="partnersErrors[idx]?.name"
                                    />
                                    <CustomInput
                                        :label="$t('website_settings.general.partner_link')"
                                        customLabelClass="poppinsLight"
                                        v-model="p.link"
                                        :placeholder="$t('website_settings.general.partner_link_placeholder')"
                                        :required="form.enabled_partenaires"
                                        :errorText="partnersErrors[idx]?.link"
                                    />
                                </div>
                            </div>
                            <hr
                                v-if="idx < partners.length - 1"
                                class="ppv2-border-b ppv2-border-black ppv2-border-opacity-20 last:ppv2-border-b-0 last:ppv2-pb-0"
                            />
                        </div>

                        <!-- Add Partner Button -->
                        <div class="ppv2-flex ppv2-justify-center ppv2-mt-4">
                            <BaseButton type="button" variant="secondary" :customFontSize="12" @click="addPartner">
                                <Plus :size="12" />
                                <span>{{ $t('website_settings.general.add_partner') }}</span>
                            </BaseButton>
                        </div>
                    </div>
                </SectionCard>

                <!-- Section Choix (Pourquoi nous ?) -->
                <SectionCard
                    :title="$t('website_settings.general.choices_section')"
                    v-model="form.enabled_choix"
                    :tooltip="$t('website_settings.general.tooltips.choices')"
                >
                    <div class="ppv2-grid ppv2-grid-cols-1 md:ppv2-grid-cols-3 ppv2-gap-8">
                        <div v-for="(choice, i) in choicesConfigs" :key="i" class="ppv2-flex ppv2-flex-col ppv2-gap-6">
                            <!-- Logo -->
                            <div>
                                <CustomInputUpload
                                    :label="$t('website_settings.general.choice_icon')"
                                    customClassLabel="poppinsLight"
                                    v-model="form[choice.imageModel]"
                                    @input="(file) => handleImageUpload(choice.uploadField, { target: { files: [file] } })"
                                    :required="false"
                                    recommendedDimensions="60 x 60 px"
                                    :errorText="errors[choice.imageModel]"
                                />
                            </div>

                            <!-- Titre de section -->
                            <div>
                                <CustomInput
                                    :label="$t('website_settings.general.choice_title')"
                                    :required="true"
                                    customLabelClass="poppinsLight"
                                    v-model="form[choice.titleModel]"
                                    :placeholder="$t('website_settings.general.choice_title_placeholder')"
                                    :errorText="errors[choice.titleModel]"
                                />
                            </div>

                            <!-- Description -->
                            <div>
                                <BaseTextarea
                                    :label="$t('website_settings.general.choice_desc')"
                                    :required="true"
                                    customLabelClass="poppinsLight"
                                    v-model="form[choice.descModel]"
                                    :rows="8"
                                    :useEditor="false"
                                    :placeholder="$t('website_settings.general.choice_desc_placeholder')"
                                    :error="errors[choice.descModel]"
                                />
                            </div>
                        </div>
                    </div>
                </SectionCard>

                <!-- Section Billet Non Daté -->
                <SectionCard
                    :title="$t('website_settings.general.undated_ticket_section')"
                    v-model="form.enabled_undated_ticket"
                    :tooltip="$t('website_settings.general.tooltips.undated_ticket')"
                    ><!--:disabled="!data.has_undated_tickets"-->
                    <template #warning>
                        <InfoBanner
                            variant="warning"
                            :text="$t('website_settings.general.undated_tickets_warning')"
                            :linkText="$t('website_settings.general.configure_now')"
                            linkUrl="/back-office/prestations"
                        />
                    </template>
                    <div class="ppv2-grid ppv2-grid-cols-1" :style="{ gap: normalizeSize(16, true) }">
                        <div>
                            <CustomInput
                                :label="$t('website_settings.general.undated_ticket_title')"
                                v-model="form.title_undated_ticket"
                                :required="form.enabled_undated_ticket"
                                :errorText="errors.title_undated_ticket"
                            />
                        </div>
                        <div>
                            <BaseTextarea
                                :label="$t('website_settings.general.undated_ticket_desc')"
                                v-model="form.desc_undated_ticket"
                                :rows="5"
                                :useEditor="false"
                                :required="form.enabled_undated_ticket"
                                :error="errors.desc_undated_ticket"
                            />
                        </div>
                        <div>
                            <CustomInputUpload
                                :label="$t('website_settings.general.cover')"
                                customClassLabel="poppinsLight"
                                v-model="form.image_cov_undated_ticket_url"
                                @input="(file) => handleImageUpload('image_cov_undated_ticket', { target: { files: [file] } })"
                                specificTaille="1000×400px"
                                :required="form.enabled_undated_ticket"
                                :errorText="errors.image_cov_undated_ticket_url"
                            />
                        </div>
                        <div>
                            <CustomInputUpload
                                :label="$t('website_settings.general.undated_ticket_image')"
                                customClassLabel="poppinsLight"
                                v-model="form.image_undated_ticket_url"
                                @input="(file) => handleImageUpload('image_undated_ticket', { target: { files: [file] } })"
                                specificTaille="300×300px"
                                :required="form.enabled_undated_ticket"
                                :errorText="errors.image_undated_ticket_url"
                            />
                        </div>
                    </div>
                </SectionCard>

                <!-- Section Offre Découverte -->
                <SectionCard
                    :title="$t('website_settings.general.discovery_offer_section')"
                    v-model="form.enabled_offre_decou"
                    :tooltip="$t('website_settings.general.tooltips.discovery_offer')"
                >
                    <div class="ppv2-grid ppv2-grid-cols-1" :style="{ gap: normalizeSize(16, true) }">
                        <div>
                            <CustomInput
                                :label="$t('website_settings.general.discovery_offer_title')"
                                customLabelClass="poppinsLight"
                                v-model="form.title_offre_decou"
                                :required="form.enabled_offre_decou"
                                :errorText="errors.title_offre_decou"
                            />
                        </div>
                        <div>
                            <BaseTextarea
                                :label="$t('website_settings.general.discovery_offer_desc')"
                                v-model="form.desc_offre_decou"
                                :rows="5"
                                :useEditor="false"
                                :required="form.enabled_offre_decou"
                                :error="errors.desc_offre_decou"
                            />
                        </div>
                        <div>
                            <CustomInputUpload
                                :label="$t('website_settings.general.discovery_offer_image')"
                                customClassLabel="poppinsLight"
                                v-model="form.image_offre_decou_url"
                                @input="(file) => handleImageUpload('image_offre_decou', { target: { files: [file] } })"
                                :required="form.enabled_offre_decou"
                                specificTaille="300×300px"
                                :errorText="errors.image_offre_decou_url"
                            />
                        </div>
                    </div>
                </SectionCard>

                <!-- Section Boutique (Shop) -->
                <!-- Removed by Théo - we won't manage Shop in the future -->
                <!--<SectionCard
                    :title="$t('website_settings.general.category_section')"
                    v-model="form.enabled_shop"
                    :tooltip="$t('website_settings.general.tooltips.shop')"
                >
                    <div class="ppv2-flex ppv2-flex-col ppv2-gap-6">
                        <div
                            v-for="cat in categoriesConfigs"
                            :key="cat.key"
                            class="ppv2-bg-black ppv2-bg-opacity-10 ppv2-rounded-2xl ppv2-p-4"
                        >
                            <h5 class="poppinsMedium ppv2-text-sm ppv2-text-gray-700 ppv2-mb-4">
                                {{ $t(cat.headerLabel || cat.titleLabel) }}
                            </h5>
                            <div class="ppv2-grid ppv2-grid-cols-1" :style="{gap: normalizeSize(16, true)}">
                                <div>
                                    <CustomInput
                                        :label="$t(cat.titleLabel)"
                                        customLabelClass="poppinsLight"
                                        v-model="form[cat.titleModel]"
                                        :required="form.enabled_shop"
                                        :errorText="errors[cat.titleModel]"
                                    />
                                </div>
                                <div class="ppv2-grid ppv2-grid-cols-1 md:ppv2-grid-cols-2" :style="{gap: normalizeSize(16, true)}">
                                    <div>
                                        <BaseTextarea
                                            :label="$t(cat.descLabel)"
                                            customLabelClass="poppinsLight"
                                            v-model="form[cat.descModel]"
                                            :rows="4"
                                            :useEditor="false"
                                            :required="form.enabled_shop"
                                            :error="errors[cat.descModel]"
                                        />
                                    </div>
                                    <div>
                                        <CustomInputUpload
                                            :label="$t(cat.imageLabel)"
                                            customClassLabel="poppinsLight"
                                            v-model="form[cat.urlModel]"
                                            @input="(file) => handleImageUpload(cat.uploadField, { target: { files: [file] } })"
                                            :required="form.enabled_shop"
                                            specificTaille="680×400px"
                                            :errorText="errors[cat.urlModel]"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </SectionCard>
                -->
            </div>
        </form>

        <!-- Delete Confirmation Dialog -->
        <CustomDialog v-model="showDeleteDialog" :defaultTitle="$t('common.confirm_delete')" noScroll>
            <template #content>
                <div class="ppv2-text-center ppv2-py-4">
                    <div class="ppv2-mb-4">
                        <TriangleAlert :size="48" class="ppv2-text-yellow-500 ppv2-inline-block" />
                    </div>
                    <p class="ppv2-text-gray-700 dark:ppv2-text-gray-300 ppv2-text-base">
                        {{ deleteDialogMessage }}
                    </p>
                </div>
            </template>
            <template #actions>
                <BaseButton variant="outline" @click="showDeleteDialog = false">{{ $t('common.cancel') }}</BaseButton>
                <BaseButton variant="danger" @click="confirmDelete">{{ $t('common.confirm') }}</BaseButton>
            </template>
        </CustomDialog>
    </div>
</template>

<script>
import BaseLabel from '../../../../Shared/BaseLabel.vue'
import BaseSwitch from '../../../../Shared/BaseSwitch.vue'
import CustomInput from '../../../../Inputs/CustomInput.vue'
import BaseTextarea from '../../../../Shared/BaseTextarea.vue'
import CustomInputUpload from '../../../../Inputs/CustomInputUpload.vue'
import CustomDialog from '../../../../Shared/CustomDialog.vue'
import BaseButton from '../../../../Shared/BaseButton.vue'
import SectionCard from './SectionCard.vue'
import InfoBanner from '../../../../Shared/InfoBanner.vue'
import { Info, Plus, X, TriangleAlert, Trash2 } from 'lucide-vue'
import normalizeSize from '../../../../../utils/normalizeSize'

export default {
    name: 'TabSections',
    components: {
        BaseLabel,
        BaseSwitch,
        CustomInput,
        BaseTextarea,
        CustomInputUpload,
        CustomDialog,
        BaseButton,
        SectionCard,
        //InfoBanner, activé plus tard
        Info,
        Plus,
        X,
        TriangleAlert,
        Trash2,
    },
    props: {
        data: { type: Object, default: () => ({}) },
        planPublishFormRequestQuotation: { type: Object, default: () => ({}) },
        tenant: { type: Object, default: () => ({}) },
    },
    data() {
        return {
            saving: false,
            partners: [{ url: null, file: null, link: '', name: '' }],
            showDeleteDialog: false,
            deleteDialogMessage: '',
            deleteAction: null,
            deleteIndex: null,
            form: {
                enabled_bon_cadeau: false,
                title_bon_cadeau: '',
                desc_bon_cadeau: '',
                image_bon_cadeau_url: null,
                image_bon_cadeau_file: null,
                image_bon_cadeau_delete: false,

                enabled_undated_ticket: false,
                title_undated_ticket: '',
                desc_undated_ticket: '',
                image_cov_undated_ticket_url: null,
                image_cov_undated_ticket_file: null,
                image_cov_undated_ticket_delete: false,
                image_undated_ticket_url: null,
                image_undated_ticket_file: null,
                image_undated_ticket_delete: false,

                enabled_offre_decou: false,
                title_offre_decou: '',
                desc_offre_decou: '',
                image_offre_decou_url: null,
                image_offre_decou_file: null,
                image_offre_decou_delete: false,

                enabled_partenaires: false,
                title_partner: '',
                // Removed by Théo - we won't manage Shop for now
                // enabled_shop: false,
                // title_categ_men: '',
                // desc_categ_men: '',
                // image_categ_homme_url: null,
                // image_categ_homme_file: null,
                // title_categ_women: '',
                // desc_categ_women: '',
                // image_categ_women_url: null,
                // image_categ_women_file: null,
                // title_categ_child: '',
                // desc_categ_child: '',
                // image_categ_enfant_url: null,
                // image_categ_enfant_file: null,
                enabled_choix: false,
                title_first_choice_iden: '',
                desc_first_choice: '',
                image_first_choice_iden_url: null,
                image_first_choice_iden_file: null,
                image_first_choice_iden_delete: false,
                title_second_choice_iden: '',
                desc_second_choice_iden: '',
                image_second_choice_iden_url: null,
                image_second_choice_iden_file: null,
                image_second_choice_iden_delete: false,
                title_third_choice_iden: '',
                desc_third_choice_iden: '',
                image_third_choice_iden_url: null,
                image_third_choice_iden_file: null,
                image_third_choice_iden_delete: false,

                enabled_demande_devis: false,
                enabled_menu_ent: true,
                enabled_menu_anv: true,
                enabled_menu_evg: true,
                title_first_demande_devis: '',
                desc_first_demande_devis: '',
                image_first_demande_devis_url: null,
                image_first_demande_devis_file: null,
                image_first_demande_devis_delete: false,
                title_second_demande_devis: '',
                desc_second_demande_devis: '',
                image_second_demande_devis_url: null,
                image_second_demande_devis_file: null,
                image_second_demande_devis_delete: false,
                title_third_demande_devis: '',
                desc_third_demande_devis: '',
                image_third_demande_devis_url: null,
                image_third_demande_devis_file: null,
                image_third_demande_devis_delete: false,
            },
            choicesConfigs: [
                {
                    titleLabel: 'website_settings.general.first_choice_title',
                    titleModel: 'title_first_choice_iden',
                    descLabel: 'website_settings.general.first_choice_desc',
                    descModel: 'desc_first_choice',
                    imageModel: 'image_first_choice_iden_url',
                    uploadField: 'image_first_choice_iden',
                },
                {
                    titleLabel: 'website_settings.general.second_choice_title',
                    titleModel: 'title_second_choice_iden',
                    descLabel: 'website_settings.general.second_choice_desc',
                    descModel: 'desc_second_choice_iden',
                    imageModel: 'image_second_choice_iden_url',
                    uploadField: 'image_second_choice_iden',
                },
                {
                    titleLabel: 'website_settings.general.third_choice_title',
                    titleModel: 'title_third_choice_iden',
                    descLabel: 'website_settings.general.third_choice_desc',
                    descModel: 'desc_third_choice_iden',
                    imageModel: 'image_third_choice_iden_url',
                    uploadField: 'image_third_choice_iden',
                },
            ],
            demandeDevisConfigs: [
                {
                    slug: 'demande-entreprise',
                    titleLabel: 'website_settings.general.demande_devis_title',
                    titleModel: 'title_first_demande_devis',
                    descLabel: 'website_settings.general.demande_devis_desc',
                    descModel: 'desc_first_demande_devis',
                    imageModel: 'image_first_demande_devis_url',
                    uploadField: 'image_first_demande_devis',
                    enabledModel: 'enabled_menu_ent',
                },
                {
                    slug: 'demande-anniversaire',
                    titleLabel: 'website_settings.general.demande_devis_title',
                    titleModel: 'title_second_demande_devis',
                    descLabel: 'website_settings.general.demande_devis_desc',
                    descModel: 'desc_second_demande_devis',
                    imageModel: 'image_second_demande_devis_url',
                    uploadField: 'image_second_demande_devis',
                    enabledModel: 'enabled_menu_anv',
                },
                {
                    slug: 'demande-evg',
                    titleLabel: 'website_settings.general.demande_devis_title',
                    titleModel: 'title_third_demande_devis',
                    descLabel: 'website_settings.general.demande_devis_desc',
                    descModel: 'desc_third_demande_devis',
                    imageModel: 'image_third_demande_devis_url',
                    uploadField: 'image_third_demande_devis',
                    enabledModel: 'enabled_menu_evg',
                },
            ],
            categoriesConfigs: [
                /* Removed by Théo
                {
                    key: 'men',
                    headerLabel: 'website_settings.general.category_men_title',
                    titleLabel: 'website_settings.general.category_title',
                    titleModel: 'title_categ_men',
                    descLabel: 'website_settings.general.category_desc',
                    descModel: 'desc_categ_men',
                    imageLabel: 'website_settings.general.category_image',
                    urlModel: 'image_categ_homme_url',
                    uploadField: 'image_categ_homme',
                },
                {
                    key: 'women',
                    headerLabel: 'website_settings.general.category_women_title',
                    titleLabel: 'website_settings.general.category_title',
                    titleModel: 'title_categ_women',
                    descLabel: 'website_settings.general.category_desc',
                    descModel: 'desc_categ_women',
                    imageLabel: 'website_settings.general.category_image',
                    urlModel: 'image_categ_women_url',
                    uploadField: 'image_categ_women',
                },
                {
                    key: 'child',
                    headerLabel: 'website_settings.general.category_child_title',
                    titleLabel: 'website_settings.general.category_title',
                    titleModel: 'title_categ_child',
                    descLabel: 'website_settings.general.category_desc',
                    descModel: 'desc_categ_child',
                    imageLabel: 'website_settings.general.category_image',
                    urlModel: 'image_categ_enfant_url',
                    uploadField: 'image_categ_enfant',
                },
                */
            ],
            errors: {},
            partnersErrors: [],
        }
    },
    watch: {
        'form.enabled_bon_cadeau'(newVal) {
            this.syncGiftSettings(newVal)
        },
        'form.enabled_offre_decou'(newVal) {
            this.syncOfferSettings(newVal)
        },
    },
    computed: {
        settings() {
            return this.data?.settings || []
        },
        hasAccess() {
            return this.access_plan(this.tenant?.plan_id, this.planPublishFormRequestQuotation)
        },
    },
    mounted() {
        this.initializeForm()
        this.$root.$on('sync-gift-settings', this.handleSyncGiftSettings)
        this.$root.$on('sync-offer-settings', this.handleSyncOfferSettings)
    },
    activated() {
        this.$root.$off('website-settings-trigger-save-sections', this.save)
        this.$root.$on('website-settings-trigger-save-sections', this.save)
    },
    deactivated() {
        this.$root.$off('website-settings-trigger-save-sections', this.save)
    },
    beforeDestroy() {
        this.$root.$off('website-settings-trigger-save-sections', this.save)
        this.$root.$off('sync-gift-settings', this.handleSyncGiftSettings)
        this.$root.$off('sync-offer-settings', this.handleSyncOfferSettings)
    },
    methods: {
        syncGiftSettings(value) {
            this.$root.$emit('sync-gift-settings', value)
        },
        syncOfferSettings(value) {
            this.$root.$emit('sync-offer-settings', value)
        },
        isBlockActive(choice, sectionToggle) {
            if (!this.form[sectionToggle]) return false
            return !!(this.form[choice.titleModel] || this.form[choice.descModel] || this.form[choice.imageModel])
        },
        normalizeSize,
        initializeForm() {
            this.settings.forEach((s) => {
                const v = s.value
                if (!v) return
                const mapping = {
                    title_bon_cadeau: 'title_bon_cadeau',
                    desc_bon_cadeau: 'desc_bon_cadeau',
                    image_bon_cadeau: 'image_bon_cadeau_url',
                    title_undated_ticket: 'title_undated_ticket',
                    desc_undated_ticket: 'desc_undated_ticket',
                    image_cov_undated_ticket: 'image_cov_undated_ticket_url',
                    image_undated_ticket: 'image_undated_ticket_url',
                    title_offre_decou: 'title_offre_decou',
                    desc_offre_decou: 'desc_offre_decou',
                    image_offre_decou: 'image_offre_decou_url',
                    title_partner: 'title_partner',
                    /* Removed by Théo
                    title_categ_men: 'title_categ_men',
                    desc_categ_men: 'desc_categ_men',
                    image_categ_homme: 'image_categ_homme_url',
                    title_categ_women: 'title_categ_women',
                    desc_categ_women: 'desc_categ_women',
                    image_categ_women: 'image_categ_women_url',
                    title_categ_child: 'title_categ_child',
                    desc_categ_child: 'desc_categ_child',
                    image_categ_enfant: 'image_categ_enfant_url',
                    */
                    title_first_choice_iden: 'title_first_choice_iden',
                    desc_first_choice: 'desc_first_choice',
                    image_first_choice_iden: 'image_first_choice_iden_url',
                    title_second_choice_iden: 'title_second_choice_iden',
                    desc_second_choice_iden: 'desc_second_choice_iden',
                    image_second_choice_iden: 'image_second_choice_iden_url',
                    title_third_choice_iden: 'title_third_choice_iden',
                    desc_third_choice_iden: 'desc_third_choice_iden',
                    image_third_choice_iden: 'image_third_choice_iden_url',
                    title_first_demande_devis: 'title_first_demande_devis',
                    desc_first_demande_devis: 'desc_first_demande_devis',
                    image_first_demande_devis: 'image_first_demande_devis_url',
                    title_second_demande_devis: 'title_second_demande_devis',
                    desc_second_demande_devis: 'desc_second_demande_devis',
                    image_second_demande_devis: 'image_second_demande_devis_url',
                    title_third_demande_devis: 'title_third_demande_devis',
                    desc_third_demande_devis: 'desc_third_demande_devis',
                    image_third_demande_devis: 'image_third_demande_devis_url',
                }
                if (mapping[s.parameter]) this.form[mapping[s.parameter]] = v

                // Toggles
                // if (s.parameter === 'enabled_shop') this.form.enabled_shop = v === 'on'
                if (s.parameter === 'enabled_bon_cadeau') {
                    this.form.enabled_bon_cadeau = v === 'on'
                }
                if (s.parameter === 'enabled_partenaires') this.form.enabled_partenaires = v === 'on'
                if (s.parameter === 'enabled_choix') this.form.enabled_choix = v === 'on'
                if (s.parameter === 'enabled_undated_ticket') this.form.enabled_undated_ticket = v === 'on'
                if (s.parameter === 'enabled_offre_decou') this.form.enabled_offre_decou = v === 'on'
                if (s.parameter === 'enabled_demande_devis') this.form.enabled_demande_devis = v === 'on'
                if (s.parameter === 'enabled_menu_ent') this.form.enabled_menu_ent = v === 'on'
                if (s.parameter === 'enabled_menu_anv') this.form.enabled_menu_anv = v === 'on'
                if (s.parameter === 'enabled_menu_evg') this.form.enabled_menu_evg = v === 'on'
            })

            // Fallback : titre vide → nom du formulaire (survey) puis libellé par défaut.
            // Miroir du fallback API (ApiEtablissementController::getSettings) et du
            // backfill seeder : un setting vide ("") ne doit pas laisser le champ vide.
            const surveysBySlug = {}
            ;(this.data?.surveys || []).forEach((survey) => {
                if (survey?.slug && typeof survey.name === 'string' && survey.name.trim() !== '') {
                    surveysBySlug[survey.slug] = survey.name
                }
            })
            const defaultTitles = {
                'demande-entreprise': 'Demande Entreprise',
                'demande-anniversaire': 'Demande Anniversaire',
                'demande-evg': 'Demande EVG',
            }
            this.demandeDevisConfigs.forEach((choice) => {
                const current = this.form[choice.titleModel]
                if (!current || String(current).trim() === '') {
                    this.form[choice.titleModel] = surveysBySlug[choice.slug] || defaultTitles[choice.slug] || ''
                }
            })

            // Load partners
            if (this.data.partners && this.data.partners.length > 0) {
                this.partners = this.data.partners.map((p) => ({
                    url: p.image_url,
                    file: null,
                    link: p.url || '',
                    name: p.name || '',
                }))
            } else {
                this.partners = [{ url: null, file: null, link: '', name: '' }]
            }
            this.partnersErrors = this.partners.map(() => ({}))
        },
        handleImageUpload(field, e) {
            const file = e.target.files ? e.target.files[0] : null
            if (file) {
                const reader = new FileReader()
                reader.onload = (ev) => {
                    this.form[field + '_url'] = ev.target.result
                }
                reader.readAsDataURL(file)
                this.form[field + '_file'] = file
                this.form[field + '_delete'] = false
            } else {
                this.form[field + '_url'] = null
                this.form[field + '_file'] = null
                this.form[field + '_delete'] = true
            }
        },
        addPartner() {
            this.partners.push({ url: null, file: null, link: '', name: '' })
            this.partnersErrors.push({})
        },
        handlePartnerUpload(idx, e) {
            const file = e.target.files[0]
            if (file) {
                const reader = new FileReader()
                reader.onload = (ev) => {
                    this.partners[idx].url = ev.target.result
                }
                reader.readAsDataURL(file)
                this.partners[idx].file = file
            }
        },
        async deletePartner(idx) {
            const partner = this.partners[idx]
            if (partner.url && !partner.file) {
                this.deleteAction = 'partner'
                this.deleteIndex = idx
                this.deleteDialogMessage = this.$t('website_settings.general.partner_delete_confirm')
                this.showDeleteDialog = true
            } else {
                this.partners.splice(idx, 1)
                this.partnersErrors.splice(idx, 1)
            }
        },
        async confirmDelete() {
            if (this.deleteAction === 'partner') {
                const idx = this.deleteIndex
                const partner = this.partners[idx]
                try {
                    await axios.post('/back-office/website/website-settings/delete-image', {
                        url: partner.url,
                        champ: 'image_slider_partner',
                    })
                    this.$toast.success(this.$t('website_settings.general.partner_deleted'))
                    this.partners.splice(idx, 1)
                    this.partnersErrors.splice(idx, 1)
                    this.$emit('refresh')
                } catch (e) {
                    this.$toast.error(this.$t('website_settings.actions.delete_error'))
                }
            }
            this.showDeleteDialog = false
        },
        handleSyncGiftSettings(value) {
            if (this.form.enabled_bon_cadeau !== value) {
                this.form.enabled_bon_cadeau = value
            }
        },
        handleSyncOfferSettings(value) {
            if (this.form.enabled_offre_decou !== value) {
                this.form.enabled_offre_decou = value
            }
        },
        async save() {
            // Validation
            this.errors = {}
            this.partnersErrors = []
            let hasError = false

            if (this.form.enabled_bon_cadeau) {
                if (!this.form.title_bon_cadeau) this.errors.title_bon_cadeau = this.$t('common.formRequiredError')
                if (!this.form.desc_bon_cadeau) this.errors.desc_bon_cadeau = this.$t('common.formRequiredError')
                if (!this.form.image_bon_cadeau_url) this.errors.image_bon_cadeau_url = this.$t('common.formRequiredError')
            }

            if (this.form.enabled_demande_devis) {
                this.demandeDevisConfigs.forEach((choice) => {
                    if (this.form[choice.enabledModel]) {
                        if (!this.form[choice.titleModel]) this.errors[choice.titleModel] = this.$t('common.formRequiredError')
                        if (!this.form[choice.descModel]) this.errors[choice.descModel] = this.$t('common.formRequiredError')
                        if (!this.form[choice.imageModel]) this.errors[choice.imageModel] = this.$t('common.formRequiredError')
                    }
                })
            }

            if (this.form.enabled_undated_ticket) {
                if (!this.form.title_undated_ticket) this.errors.title_undated_ticket = this.$t('common.formRequiredError')
                if (!this.form.desc_undated_ticket) this.errors.desc_undated_ticket = this.$t('common.formRequiredError')
                if (!this.form.image_cov_undated_ticket_url)
                    this.errors.image_cov_undated_ticket_url = this.$t('common.formRequiredError')
                if (!this.form.image_undated_ticket_url)
                    this.errors.image_undated_ticket_url = this.$t('common.formRequiredError')
            }

            if (this.form.enabled_offre_decou) {
                if (!this.form.title_offre_decou) this.errors.title_offre_decou = this.$t('common.formRequiredError')
                if (!this.form.desc_offre_decou) this.errors.desc_offre_decou = this.$t('common.formRequiredError')
                if (!this.form.image_offre_decou_url) this.errors.image_offre_decou_url = this.$t('common.formRequiredError')
            }

            if (this.form.enabled_choix) {
                this.choicesConfigs.forEach((choice) => {
                    if (!this.form[choice.titleModel]) this.errors[choice.titleModel] = this.$t('common.formRequiredError')
                    if (!this.form[choice.descModel]) this.errors[choice.descModel] = this.$t('common.formRequiredError')
                })
            }

            if (this.form.enabled_partenaires) {
                this.partnersErrors = this.partners.map(() => ({}))
                this.partners.forEach((p, idx) => {
                    const pErrors = {}
                    if (!p.url) pErrors.url = this.$t('common.formRequiredError')
                    if (!p.name) pErrors.name = this.$t('common.formRequiredError')
                    if (!p.link) pErrors.link = this.$t('common.formRequiredError')

                    if (Object.keys(pErrors).length > 0) {
                        this.partnersErrors[idx] = pErrors
                        hasError = true
                    }
                })
            }

            if (Object.keys(this.errors).length > 0 || hasError) {
                this.$toast.error(this.$t('common.formValidationError'))
                return
            }

            this.saving = true
            this.$emit('save', { loading: true })
            try {
                const fd = new FormData()
                // All text fields
                const textFields = [
                    'title_bon_cadeau',
                    'desc_bon_cadeau',
                    'title_undated_ticket',
                    'desc_undated_ticket',
                    'title_offre_decou',
                    'desc_offre_decou',
                    'title_partner',
                    /* Removed by Théo
                    'title_categ_men',
                    'desc_categ_men',
                    'title_categ_women',
                    'desc_categ_women',
                    'title_categ_child',
                    'desc_categ_child',
                    */
                    'title_first_choice_iden',
                    'desc_first_choice',
                    'title_second_choice_iden',
                    'desc_second_choice_iden',
                    'title_third_choice_iden',
                    'desc_third_choice_iden',
                    'title_first_demande_devis',
                    'desc_first_demande_devis',
                    'title_second_demande_devis',
                    'desc_second_demande_devis',
                    'title_third_demande_devis',
                    'desc_third_demande_devis',
                ]
                textFields.forEach((f) => fd.append(f, this.form[f] || ''))

                // Toggles
                const toggles = [
                    'enabled_bon_cadeau',
                    'enabled_partenaires',
                    'enabled_choix',
                    'enabled_undated_ticket',
                    'enabled_offre_decou',
                    'enabled_demande_devis',
                    'enabled_menu_ent',
                    'enabled_menu_anv',
                    'enabled_menu_evg',
                    // 'enabled_shop',
                ]
                toggles.forEach((t) => fd.append(t, this.form[t] ? 'on' : 'off'))

                // Ensure both gift and offer fields are sent for synchronization
                fd.append('enabled_menu_gift', this.form.enabled_bon_cadeau ? 'on' : 'off')
                fd.append('enabled_menu_offer', this.form.enabled_offre_decou ? 'on' : 'off')

                // Image files
                const imageFields = [
                    'image_bon_cadeau',
                    'image_cov_undated_ticket',
                    'image_undated_ticket',
                    'image_offre_decou',
                    /* Removed by Théo
                    'image_categ_homme',
                    'image_categ_women',
                    'image_categ_enfant',
                    */
                    'image_first_choice_iden',
                    'image_second_choice_iden',
                    'image_third_choice_iden',
                    'image_first_demande_devis',
                    'image_second_demande_devis',
                    'image_third_demande_devis',
                ]
                imageFields.forEach((f) => {
                    if (this.form[f + '_file']) {
                        fd.append(f, this.form[f + '_file'])
                    } else if (this.form[f + '_delete']) {
                        fd.append(f, '') // Signal deletion to the backend
                        fd.append(f + '_delete', '1') // Trigger explicit deletion on the backend
                    }
                })

                // Partners
                this.partners.forEach((p) => {
                    if (p.file) {
                        fd.append('image_slider_partner[]', p.file)
                        fd.append('image_slider_partner_nom[]', p.name || '')
                        fd.append('image_slider_partner_desc[]', p.link || '')
                    } else if (p.url) {
                        fd.append('image_old_slider_partner_urls[]', p.url || '') // URL for image check
                        fd.append('image_old_slider_partner_links[]', p.link || '') // Original link
                        fd.append('image_old_slider_partner_noms[]', p.name || '') // Original name
                    }
                })

                const response = await axios.post('/back-office/website/website-settings', fd)
                this.$emit('save', { loading: false, success: true, message: response.data?.message })
            } catch (error) {
                this.$toast.error(error.response.data.message)
                this.$emit('save', { loading: false })
            } finally {
                this.saving = false
            }
        },
        access_plan(user_plan_id, plan) {
            if (!plan) return false
            return user_plan_id >= plan.min_plan_level || plan.is_given_by_super_admin
        },
    },
}
</script>
